/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = require('redux');

var _action_types = require('../../action_types');

var _helpers = require('./helpers');

function server() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    if (action.type === _action_types.GeneralTypes.PING_RESET) {
        return (0, _helpers.initialRequestState)();
    }

    return (0, _helpers.handleRequest)(_action_types.GeneralTypes.PING_REQUEST, _action_types.GeneralTypes.PING_SUCCESS, _action_types.GeneralTypes.PING_FAILURE, state, action);
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function config() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.GeneralTypes.CLIENT_CONFIG_REQUEST, _action_types.GeneralTypes.CLIENT_CONFIG_SUCCESS, _action_types.GeneralTypes.CLIENT_CONFIG_FAILURE, state, action);
}

function license() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.GeneralTypes.CLIENT_LICENSE_REQUEST, _action_types.GeneralTypes.CLIENT_LICENSE_SUCCESS, _action_types.GeneralTypes.CLIENT_LICENSE_FAILURE, state, action);
}

function websocket() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    if (action.type === _action_types.GeneralTypes.WEBSOCKET_CLOSED) {
        return (0, _helpers.initialRequestState)();
    }

    return (0, _helpers.handleRequest)(_action_types.GeneralTypes.WEBSOCKET_REQUEST, _action_types.GeneralTypes.WEBSOCKET_SUCCESS, _action_types.GeneralTypes.WEBSOCKET_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    server: server,
    config: config,
    license: license,
    websocket: websocket
});



//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/reducers/requests/general.js
// module id = 1224
// module chunks = 60